const contentful = require('contentful');

class ContentfulClient {

  constructor() {
    this.personalAccessToken = process.env.CF_PERSONAL_ACCESS_TOKEN;
    this.deliveryAccessToken = process.env.CF_DELIVERY_ACCESS_TOKEN;
    const preview = process.env.PREVIEW === 'true' ? true : false;
    this.spaceId = process.env.CF_SPACE_ID;
    this.siteLocale = process.env.SITE_LOCALE;
    this.environmentId = process.env.CF_ENVIRONMENT;

    if(this.deliveryAccessToken && this.deliveryAccessToken !== '') {
      this.contentfulClient = contentful.createClient({
        space: this.spaceId,
        accessToken: preview ? process.env.CF_PREVIEW_ACCESS_TOKEN : this.deliveryAccessToken,
        environment: this.environmentId,
        host: preview ? process.env.CF_HOST : '',
      });
    }

  }

  static create() {
    return new ContentfulClient();
  }
  getPersonalAccessToken() {
    return this.personalAccessToken;
  }
  getDeliveryAccessToken() {
    return this.deliveryAccessToken;
  }
  getSpaceId() {
    return this.spaceId;
  }
  getEnvironmentId() {
    return this.environmentId;
  }

  async getClient() {
    return this.contentfulClient;
  }

  getSiteLocale() {
    return process.env.SITE_LOCALE || this.siteLocale;
  }p
}

export default new ContentfulClient();